export const OVERLOOKSCOMMENTS = [
    {
        id: 0,
        overlookId: 0,
        text: 'It was an amazing view!'
    },
    {
        id: 1,
        overlookId: 0,
        text: 'The view was even better the second time!'
    },
    {
        id: 2,
        overlookId: 1,
        text: 'Love this lookout!'
    },
    {
        id: 3,
        overlookId: 1,
        text: 'Its all overgrown now...'
    },
    {
        id: 4,
        overlookId: 2,
        text: 'So glad i found this view!'
    },
    {
        id: 5,
        overlookId: 2,
        text: 'The view is even better than before!'
    },
]